import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-filter-group',
  standalone: false,
  templateUrl: './filter-group.component.html',
  styleUrl: './filter-group.component.scss',
})
export class FilterGroupComponent implements OnInit, OnChanges {
  @Input() filters: any = [
    // {
    //   name: 'Channel',
    //   options: [],
    //   menuWidth: 300,
    //   enableSearch: true,
    //   displayName: 'Channel',
    // },
    // {
    //   name: 'Sub_channel',
    //   options: [],
    //   menuWidth: 300,
    //   enableSearch: true,
    //   displayName: 'Sub Channel',
    // },
    // {
    //   name: 'mc_pricing',
    //   options: [],
    //   menuWidth: 300,
    //   enableSearch: true,
    //   displayName: 'MC Pricing',
    // },
  ];

  events = {
    reset: 'reset',
  };

  @Input() newFiltersOptions: any = {};
  @Input() defaultFilterOption = {};
  @Output() selectionChanged = new EventEmitter<any>();
  @Input() resetOtherFiltersBasedCurrentSelection = true;
  @Input() addLeftToRightDisableFunctionality = true;
  @Input() showResetButton = false;
  @Input() isDisabledMenu: boolean = false;

  selectedFilters: any = {};

  constructor() {}

  ngOnInit(): void {
    // this.filters = this.filters.map((obj) => {
    //   obj.options = this.createObjForMultipleFilter(obj.options);
    //   return obj;
    // });
  }
  ngOnChanges(changes) {
    console.log(changes);
    console.log('changes');
    console.log('changes');
    if (changes.newFiltersOptions || changes.defaultFilterOption) {
      //  this.newFiltersOptions = changes.newFiltersOptions['currentValue'];
      this.filters = this.commonOptionsUpdate();
    }
    if (changes.filters) {
      //  this.newFiltersOptions = changes.newFiltersOptions['currentValue'];
      //this.filters=changes.filters['currentValue']
      // this.filters = this.commonOptionsUpdate();
    }
  }
  filterChange(eventObj) {
    // console.log(eventObj);
    this.selectedFilters[eventObj.name] = eventObj['selectedFilters'];
    if (
      eventObj.event === 'apply' ||
      eventObj.event === 'clear' ||
      !this.selectedFilters[eventObj.name].length ||
      eventObj.isSingleSelection
    ) {
      if (this.resetOtherFiltersBasedCurrentSelection) {
        // if (
        //   !this.selectedFilters[eventObj.name].length ||
        //   eventObj.isSingleSelection
        // ) {
        // reset the filters if any of the forward filters cleared.
        const index = this.filters.findIndex(
          (obj) => obj.name === eventObj.name,
        );
        this.resetFiltersBasedOnCurrentFilter(index);
        // }
      }
    }

    this.selectionChanged.emit(this.addCurrentSelections(eventObj));
  }

  checkObjectProperties(obj) {
    // for (const prop in obj) {
    //   if (
    //     obj.hasOwnProperty(prop) &&
    //     Array.isArray(obj[prop]) &&
    //     obj[prop].length >= 1
    //   ) {
    //     return true;
    //   }
    // }
    // return false;
    for (const prop in obj) {
      if (
        !obj.hasOwnProperty(prop) ||
        !Array.isArray(obj[prop]) ||
        obj[prop].length < 1
      ) {
        return false;
      }
    }
    return true;
  }

  addCurrentSelections(eventObj) {
    eventObj['overAllSelections'] = cloneDeep(this.selectedFilters);
    eventObj['selectedFiltersStatus'] = this.checkObjectProperties(
      this.selectedFilters,
    );
    //this.defaultFilterOption={}
    return eventObj;
  }

  resetFiltersBasedOnCurrentFilter(index) {
    this.filters = this.filters.map((o, i) => {
      if (i > index) {
        o.selectedFilters = [];
        o.options = o.options.map((fil) => {
          fil.selected = false;
          return fil;
        });
        delete this.selectedFilters[o.name];
      }
      return o;
    });
  }

  commonOptionsUpdate() {
    console.log('common updates============>');
    return this.filters.map((obj, i) => {
      if (this.newFiltersOptions[obj.name]) {
        // assign new filter options
        obj.options = cloneDeep(
          this.createObjForMultipleFilter(this.newFiltersOptions[obj.name]),
        );
        // update the state of new options with old selected options
        obj.options = cloneDeep(
          this.updatePreviousSelections(
            obj.options,
            this.selectedFilters,
            obj.name,
          ),
        );
        obj.options = cloneDeep(
          this.updatePreviousSelections(
            obj.options,
            this.defaultFilterOption,
            obj.name,
          ),
        );
        let response = {
          selectedFilters: this.defaultFilterOption[obj.name],
          overAllSelections: this.defaultFilterOption,
          name: obj.name,
          event: 'DefaultApply',
          isSingleSelection: null,
          selectedFiltersStatus: false,
        };
        if (Object.keys(this.defaultFilterOption).length) {
          //this.selectionChanged.emit(this.addCurrentSelections(response))
          this.filterChange(response);
        }
      }
      // disable functionality
      if (this.addLeftToRightDisableFunctionality) {
        if (i != 0) {
          let temp = this.selectedFilters[this.filters[i - 1].name]?.length;
          console.log('temp=>', temp);
          obj.isDisabled = temp ? false : true;
        }
      }
      return obj;
    });
  }

  createObjForMultipleFilter(arr) {
    return arr.map((val, index) => {
      // if (typeof val === "string") {
      return { id: index + 1, name: val, disabled: false, selected: false };
      // }
      // return val;
    });
  }
  updatePreviousSelections(options, previousSelections, name) {
    return options.map((option) => {
      if (previousSelections[name]) {
        if (previousSelections[name].includes(option.name)) {
          option.selected = true;
        }
      }
      return option;
    });
  }
  resetFilters() {
    this.selectedFilters = {};
    this.filters = this.filters.map((obj, i) => {
      obj.options = obj.options.map((o) => {
        o.selected = false;
        return o;
      });
      if (this.addLeftToRightDisableFunctionality) {
        if (i != 0) {
          let temp = this.selectedFilters[this.filters[i - 1].name]?.length;
          obj.isDisabled = temp ? false : true;
        }
      }
      return obj;
    });
    let response = {
      selectedFilters: [],
      name: this.events.reset,
      event: this.events.reset,
      isSingleSelection: null,
      selectedFiltersStatus: false,
    };
    this.filterChange(response);
  }
}
